import { RiskImpact } from '@/app/components/action-plan/types';
import { formatCancerTypeNameWithCapitalization } from '../types';
import { getCancerRiskSuffix } from './get-cancer-risk-suffix';

export function formatCancerAndOthersRiskNameText(args: {
  reducedRisk: RiskImpact;
  cancersAffected: RiskImpact[];
  otherCancers: number;
}) {
  if (args.cancersAffected.length === 0) {
    return 'Overall cancer risk';
  }

  const primaryCancerText = `${formatCancerTypeNameWithCapitalization(
    args.reducedRisk.cancerType
  )}${getCancerRiskSuffix(args.reducedRisk.cancerType)} risk`;

  return args.otherCancers === 0 ? primaryCancerText : `${primaryCancerText} + ${args.otherCancers} other cancers`;
}
